import { Box, Grid } from "@mui/material";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import useCategory from "../hooks/useCategory";

const Title = styled.div`
  font-family: Manrope;
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding-bottom: 16px;
  margin-bottom: 16px;
`;
const SubTitle = styled.div`
  //styleName: Text/M/2;
  font-family: Manrope;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  padding-bottom: 8px;
`;
const InfoTitle = styled.div`
  //styleName: Text/S/1;
  font-family: Manrope;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding-top: 32px;
`;

const Footer = () => {
  const navigate = useNavigate();
  const { categories } = useCategory();
  // const arr1 = [
  //   "Программирование",
  //   "Дизайн",
  //   "Аналитика",
  //   "Маркетинг",
  //   "Менеджмент",
  //   "Финансы",
  //   "HR",
  //   "Маркетплейсы",
  //   "Английский язык",
  // ];
  const arr2 = ["О нас", "Центр карьеры", "Контакты"];

  return (
    <>
      <Box
        sx={{
          background: "rgba(1, 18, 36, 1)",
          width: "100%",
        }}
        className="footer">
        <Box
          sx={{
            color: "white",
            display: "flex",
            width: "1224px",
            flexDirection: "column",
            margin: " 0 auto",
            padding: "40px 0",
          }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
            }}>
            <Box
              sx={{
                marginRight: "16px",
              }}>
              <Title>Направления</Title>
              <Grid container rowSpacing={0}>
                {categories.slice(0, 9).map((el: any) => (
                  <Grid
                    item
                    xs={6}
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/search/${el.id}`)}
                    key={el.id}>
                    <SubTitle>{el.name}</SubTitle>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box
              sx={{
                marginRight: "16px",
              }}>
              <Title>HiStudy</Title>
              <Box>
                {arr2.map((el) => (
                  <Grid item style={{ cursor: "pointer" }} xs={6} key={el}>
                    <SubTitle>{el}</SubTitle>
                  </Grid>
                ))}
              </Box>
            </Box>
          </Box>
          <InfoTitle>Все права защищены © HiStudy, 2023</InfoTitle>
        </Box>
      </Box>

      <Box
        sx={{
          background: "rgba(1, 18, 36, 1)",
          width: "100%",
        }}
        className="footer-mobile">
        <Box
          sx={{
            color: "white",
            display: "flex",
            flexDirection: "column",
            margin: " 0 auto",
          }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr",
            }}>
            <Box>
              <Title>Направления</Title>
              <Grid container rowSpacing={0}>
                {categories.slice(0, 9).map((el: any) => (
                  <Grid
                    item
                    xs={6}
                    style={{ cursor: "pointer", width: "100%" }}
                    onClick={() => navigate(`/search/${el.id}`)}
                    key={el.id}>
                    <SubTitle>{el.name}</SubTitle>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Box
              sx={{
                marginRight: "0",
              }}>
              <Title>HiStudy</Title>
              <Box>
                {arr2.map((el) => (
                  <Grid item style={{ cursor: "pointer" }} xs={6} key={el}>
                    <SubTitle>{el}</SubTitle>
                  </Grid>
                ))}
              </Box>
            </Box>
          </Box>

          <InfoTitle>Все права защищены © HiStudy, 2023</InfoTitle>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
